import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const QuizConfirmPlayDialog = ({
  title = '',
  description = '',
  onPlay = () => {},
  onCancel = () => {},
  isOpen = false
}) => {
  const { t } = useTranslation();

  const theme = useTheme();

  return (
    <Dialog open={isOpen} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogContent>
        <Stack spacing={3}>
          <Stack spacing={2}>
            <Typography variant='h3' color={theme.palette.grey[200]}>
              {title}
            </Typography>
            <Typography color={theme.palette.grey[200]}>
              {description}
            </Typography>
          </Stack>
          <Stack spacing={3} direction='row' justifyContent='flex-end'>
            <Button onClick={onCancel} variant='text' color='primary'>
              {t('play_quiz_activity_dialog_cancel')}
            </Button>
            <Button
              onClick={onPlay}
              variant='contained'
              color='primary'
              disableElevation
            >
              {t('play_quiz_activity_dialog_play')}
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

QuizConfirmPlayDialog.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onPlay: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default QuizConfirmPlayDialog;
